"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyUpdateIds = void 0;
var lodash_1 = __importDefault(require("lodash"));
function setDefault(container, id, type) {
    var _a;
    if (!id) {
        return;
    }
    if (!(container === null || container === void 0 ? void 0 : container[id])) {
        container[id] = {};
    }
    if (!((_a = container[id]) === null || _a === void 0 ? void 0 : _a[type])) {
        container[id][type] = { add: [], del: [] };
    }
}
function applyUpdateIds(ids, updateIds) {
    if (!updateIds)
        return ids;
    lodash_1.default.forEach(updateIds.add, function (addId) {
        if (!lodash_1.default.includes(ids, addId)) {
            ids.push(addId);
        }
    });
    lodash_1.default.forEach(updateIds.del, function (delId) {
        var idx = ids.indexOf(delId);
        if (idx > -1) {
            ids.splice(idx, 1);
        }
    });
    return ids;
}
exports.applyUpdateIds = applyUpdateIds;
var UpdateIdContainer = /** @class */ (function () {
    function UpdateIdContainer() {
        this.container = {};
    }
    UpdateIdContainer.prototype.add = function (id, type, typeId) {
        var _a;
        if (!id) {
            return;
        }
        setDefault(this.container, id, type);
        (_a = this.container[id][type]) === null || _a === void 0 ? void 0 : _a.add.push(typeId);
    };
    UpdateIdContainer.prototype.del = function (id, type, typeId) {
        var _a;
        if (!id) {
            return;
        }
        setDefault(this.container, id, type);
        (_a = this.container[id][type]) === null || _a === void 0 ? void 0 : _a.del.push(typeId);
    };
    UpdateIdContainer.prototype.adds = function (ids, type, typeId) {
        var _this = this;
        lodash_1.default.forEach(ids, function (id) { return _this.add(id, type, typeId); });
    };
    UpdateIdContainer.prototype.dels = function (ids, type, typeId) {
        var _this = this;
        lodash_1.default.forEach(ids, function (id) { return _this.del(id, type, typeId); });
    };
    UpdateIdContainer.prototype.get = function (id) {
        var _a;
        return (_a = this.container) === null || _a === void 0 ? void 0 : _a[id];
    };
    UpdateIdContainer.prototype.values = function () {
        return this.container;
    };
    return UpdateIdContainer;
}());
exports.default = UpdateIdContainer;
//# sourceMappingURL=UpdateContainer.js.map